import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { ReviewInfoModel } from '@app/custom/cms-components/pdp/models/turn-to/review/review-info.model'
import { ReviewItemModel } from '@app/custom/cms-components/pdp/models/turn-to/review/review-item.model'
import { OccEndpointsService } from '@spartacus/core'
import { catchError, filter, map, Observable, of, ReplaySubject, take, tap } from 'rxjs'

export interface TurnToReviewsList {
  reviews?: ReviewItemModel[];
}

@Injectable({
  providedIn: 'root'
})

export class TurnToEndpointService {
  private occEndpointService = inject(OccEndpointsService)
  private http = inject(HttpClient)
  private REVIEW_COUNT = '5'
  ugcStorage: Map<string, Observable<unknown>> = new Map<string, Observable<unknown>>()
  endpointUrl: string = this.occEndpointService.getBaseUrl()

  getTurnToReviewSummaryData (productCode: string): Observable<ReviewInfoModel> {
    const url = this.endpointUrl + '/integrations/turnto/ccg/ugc'
    const params = {
      productCode,
      fields: 'FULL'
    }
    const mapValue = this.ugcStorage.get(productCode)
    if (mapValue) {
      return mapValue.pipe(
        take(1),
        map(value => value as ReviewInfoModel)
      )
    } else {
      const valueToStore = new ReplaySubject()
      this.ugcStorage.set(productCode, valueToStore)
      return this.http.get(url, { params }).pipe(
        filter(Boolean),
        map(data => (data as unknown) as ReviewInfoModel),
        tap(responseFromUgc => {
          valueToStore.next(responseFromUgc)
        })
      )
    }
  }

  getTurnToReviews (productCode: string): Observable<ReviewItemModel[]> {
    const url = this.endpointUrl + '/integrations/turnto/ccg/reviews/' + productCode

    const count = this.REVIEW_COUNT
    const params = {
      count
    }
    return this.http
      .get<TurnToReviewsList>(url, { params })
      .pipe(
        map(data => data.reviews ?? []),
        catchError(() => of([]))
      )
  }

  getTurnToReviewDetailsData (productCode: string): Observable<ReviewItemModel> {
    const url = this.endpointUrl + '/integrations/turnto/ccg/review/' + productCode
    const params = {
      productCode
    }
    return this.http.get(url, { params }).pipe(
      filter(data => Boolean(data)),
      map(data => (data as unknown) as ReviewItemModel)
    )
  }
}